/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HostNameAndCsvLinkData } from './HostNameAndCsvLinkData';
import {
    HostNameAndCsvLinkDataFromJSON,
    HostNameAndCsvLinkDataFromJSONTyped,
    HostNameAndCsvLinkDataToJSON,
    HostNameAndCsvLinkDataToJSONTyped,
} from './HostNameAndCsvLinkData';

/**
 * 
 * @export
 * @interface HeurekaIntegrationInput
 */
export interface HeurekaIntegrationInput {
    /**
     * 
     * @type {Array<HostNameAndCsvLinkData>}
     * @memberof HeurekaIntegrationInput
     */
    hostNameAndCsvLinkList?: Array<HostNameAndCsvLinkData>;
}

/**
 * Check if a given object implements the HeurekaIntegrationInput interface.
 */
export function instanceOfHeurekaIntegrationInput(value: object): value is HeurekaIntegrationInput {
    return true;
}

export function HeurekaIntegrationInputFromJSON(json: any): HeurekaIntegrationInput {
    return HeurekaIntegrationInputFromJSONTyped(json, false);
}

export function HeurekaIntegrationInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): HeurekaIntegrationInput {
    if (json == null) {
        return json;
    }
    return {
        
        'hostNameAndCsvLinkList': json['hostNameAndCsvLinkList'] == null ? undefined : ((json['hostNameAndCsvLinkList'] as Array<any>).map(HostNameAndCsvLinkDataFromJSON)),
    };
}

export function HeurekaIntegrationInputToJSON(json: any): HeurekaIntegrationInput {
    return HeurekaIntegrationInputToJSONTyped(json, false);
}

export function HeurekaIntegrationInputToJSONTyped(value?: HeurekaIntegrationInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hostNameAndCsvLinkList': value['hostNameAndCsvLinkList'] == null ? undefined : ((value['hostNameAndCsvLinkList'] as Array<any>).map(HostNameAndCsvLinkDataToJSON)),
    };
}

